'use es6';

import { createContext } from 'react';
export const AuthedI18nContext = /*#__PURE__*/createContext(null);
export const PublicI18nContext = /*#__PURE__*/createContext(null);